<template>
  <div>
    <div class="h-10 py-2 px-4 text-base font-bold bg-dark-2 text-[#FFCC01] flex items-center gap-2">
      <ImgIcon
        :src="icon"
        size="24px"
      />
      오늘의 경기
    </div>
    <div class="bg-dark-4 flex gap-px">
      <template v-for="[id, sport] in sports.entries()">
        <RouterLink
          v-if="!sport.name.includes(['배드민턴'])"
          :to="{name: 'pregames', params: {sport:id}}"
          class="w-full !bg-dark-1 h-12 flex flex-nowrap items-center gap-5 py-2 px-4"
        >
          <SvgIcon
            :name="`sport-${sport.icon}`"
            size="18px"
          />
          <div class="flex items-center justify-between w-full gap-2">
            <span>{{ sport.name }}</span>
            <span v-if="drawerStore.sportCount[id]?.length > 0">({{ drawerStore.sportCount[id]?.length }})</span>
          </div>
        </RouterLink>
      </template>
    </div>
  </div>
</template>

<script setup>
import icon from '@/icons/drawer/sport.svg'
import ImgIcon from '@/components/Icons/ImgIcon.vue'
import SvgIcon from '@/components/Icons/SvgIcon.vue'
import {useSport} from '@/composables/useSport.js'
import {useDrawerStore} from '@/stores/drawer'

const { sports } = useSport()
const drawerStore = useDrawerStore()
</script>
